/**
 * Étoile de choix du téléphone favori (formulaire utilisateur, Mon compte).
 * La case à cocher `favoriteInput` reste la source de vérité : cochée = numéro secondaire favori.
 * Si un seul numéro valide est saisi, il devient favori d'office.
 */
export function initPhoneFavorite(phoneInput, mobilePhoneInput, favoriteInput)
{
    const phoneWrapper = phoneInput.closest('.phone-favorite-wrapper');
    const mobileWrapper = mobilePhoneInput.closest('.phone-favorite-wrapper');

    function refresh() {
        const isMobile = favoriteInput.is(':checked');
        phoneWrapper.toggleClass('--is-favorite', !isMobile);
        mobileWrapper.toggleClass('--is-favorite', isMobile);
    }

    function autoFavoriteWhenSingleValid() {
        const principalVal = (phoneInput.val() || '').trim();
        const secondaryVal = (mobilePhoneInput.val() || '').trim();
        const principalValid = principalVal !== '' && !phoneInput.hasClass('--error');
        const secondaryValid = secondaryVal !== '' && !mobilePhoneInput.hasClass('--error');

        if (principalValid && secondaryVal === '' && favoriteInput.is(':checked')) {
            favoriteInput.prop('checked', false).trigger('change');
        } else if (secondaryValid && principalVal === '' && !favoriteInput.is(':checked')) {
            favoriteInput.prop('checked', true).trigger('change');
        }
    }

    phoneWrapper.add(mobileWrapper).find('.favorite-badge').on('click', function () {
        const shouldBeMobile = $(this).closest('.phone-favorite-wrapper').data('favorite') === 'mobilePhoneNumber';
        if (favoriteInput.is(':checked') !== shouldBeMobile) {
            favoriteInput.prop('checked', shouldBeMobile).trigger('change');
        }
    });

    phoneInput.on('phone-validated input', autoFavoriteWhenSingleValid);
    mobilePhoneInput.on('phone-validated input', autoFavoriteWhenSingleValid);
    favoriteInput.on('change', refresh);
    refresh();
    autoFavoriteWhenSingleValid();
}
